import { render, staticRenderFns } from "./SearchAsyncSuggestions.vue?vue&type=template&id=e080b37e&"
import script from "./SearchAsyncSuggestions.vue?vue&type=script&lang=js&"
export * from "./SearchAsyncSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports